import { Card } from "@/components/ui/card";
import { Globe, Construction } from "lucide-react";

export const ReputationPublishPage = () => {
  return (
    <div className="space-y-6" data-testid="reputation-publish-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "var(--font-heading)" }}>
          Reputation — WordPress Publish
        </h1>
        <p className="text-slate-500 mt-1">
          Push generated Reputation Recovery pages to FakeReviewRemovalPro.com (WordPress).
        </p>
      </div>
      <Card className="p-10 text-center" data-testid="publish-coming-soon">
        <Construction className="w-12 h-12 text-orange-500 mx-auto mb-4" />
        <h2 className="text-xl font-semibold mb-2 flex items-center justify-center gap-2">
          <Globe className="w-5 h-5" /> Coming in Étape 5
        </h2>
        <p className="text-slate-600 max-w-xl mx-auto">
          This screen will batch-publish pages to WordPress with RankMath SEO sync,
          following the same pattern as the A-Star GEO publisher.
        </p>
      </Card>
    </div>
  );
};

export default ReputationPublishPage;
